import React from "react";

const Footer = ({
    company = "Five Dots Solutions Pvt. Ltd.",
    year = new Date().getFullYear()
}) => {
    return (
        <div
            className="text-center p-2 p-md-3 text-sm bg-dark text-white"
            style={{ marginTop: "auto", flexShrink: 0 }}
        >
            <span style={{ fontSize: "clamp(10px, 1vw, 13px)" }}>
                Copyright © {year} {company} All Rights Reserved.
            </span>
        </div>
    );
};

export default Footer;